var React = require('react');

function IcShareLdDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.048 30.048h-4.825v-8.143c0-1.279-1.436-2.34-2.715-2.34-1.278 0-2.11 1.061-2.11 2.34v8.143h-4.826V15.572h4.825v2.412c.796-1.29 2.847-2.123 4.222-2.123 3.016 0 5.429 2.461 5.429 5.44v8.747zm-16.889 0H8.334V15.572h4.825v14.476zM10.746 8.333a2.413 2.413 0 110 4.826 2.413 2.413 0 010-4.826z","fill":"currentColor"}));
}

IcShareLdDark.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IcShareLdDark;

IcShareLdDark.default = IcShareLdDark;
